import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import { AgChartsCommunityModule } from 'ag-charts-community';
import { environment } from './environments/environment';
import './ag-charts-modules';

ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsCommunityModule)]);

LicenseManager.setLicenseKey(environment.agGridLicenseKey);

// Bootstrap the application with appConfig
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
